import AppConsts from '../lib/appconst';

//为ServiceProxy子类提供BaseUrl和AxiosInstance
class ServiceProxyBase {
  protected getBaseUrl = (defaultUrl: string): string => {
    return (defaultUrl?.trim() || AppConsts.remoteServiceBaseUrl).replace(/[/]$/, "");
  }
}
export default ServiceProxyBase;
